import { useApolloClient } from "@apollo/client";
import { ISelectOption } from "@santa/common/lib/utils/form";

import {
  FirstNameSearchQuery,
  FirstNameSearchQueryVariables,
  FirstNameSearchDocument,
} from "../../../../../../types/graphql";

type UseSearch = () => (search: string) => Promise<ISelectOption[]>;

export const useSearch: UseSearch = () => {
  const client = useApolloClient();

  return async (search: string): Promise<ISelectOption[]> => {
    const { data } = await client.query<FirstNameSearchQuery, FirstNameSearchQueryVariables>({
      query: FirstNameSearchDocument,
      variables: { search },
    });

    return data.firstNames.map(o => ({
      value: o.id,
      label: o.label || "",
    }));
  };
};
